/*global mod*/

mod.modules.define("DashboardPage", function (fn) {

	fn.prototype.init = function () {
		this.attachSortable();
	};

	fn.prototype.attachSortable = function () {
		var margin = 20;

		this.el.find("#dashboard-sub-modules").sortable({
			//grid: [300, 400 + margin],
			forcePlaceholderSize: true,
			handle: ".module-header",
			containment: "parent",
			revert: 100,
			tolerance: "pointer",
			cursor: "move",
			scroll: false,
			defaultItem: $("<li />")
		});

		this.el.find("#dashboard-modules").sortable({
			//grid: [300, 400 + margin],
			forcePlaceholderSize: true,
			handle: ".module-header",
			containment: "parent",
			revert: 100,
			tolerance: "pointer",
			cursor: "move",
			scroll: false,
			defaultItem: $("<li />")
		});

	};

	fn.prototype.observables = {
		"module - removed": function (module) {
			module.el.closest("li").remove();
		}
	};

	fn.prototype.events = {
		".module-minimize": {
			"click": function (e, $el) {
				var parentModule = $el.parents(".module");
				var moduleContent = parentModule.find(".module-content");

				if(moduleContent) {
					moduleContent.hide();
				}

				var moduleContent = parentModule.find(".dashboard-wide-module-content");

				if(moduleContent) {
					moduleContent.hide();
				}

				$el.removeClass("module-minimize");
				$el.addClass("module-maximize");
			}
		},
		".module-maximize": {
			"click": function (e, $el) {
				var parentModule = $el.parents(".module");

				var moduleContent = parentModule.find(".module-content");

				if(moduleContent) {
					moduleContent.show();
				}

				var moduleContent = parentModule.find(".dashboard-wide-module-content");
				
				if(moduleContent) {
					moduleContent.show();
				}

				$el.removeClass("module-maximize");
				$el.addClass("module-minimize");
			}
		}
	};
});